import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import Checkbox from "../../../../../../../../components/shared/inputs/Checkbox";
import ShiftTooltip from "../../../../../components/tooltip/ShiftTooltip";
import { useScheduleContext } from "../../../../../hooks/context/useScheduleContext";
import { useMenuContext } from "../../../../../hooks/context/useMenuContext";
import { useShiftPreferenceStyle } from "../../../../../hooks/styles/useShiftPreferenceStyle";
import { renderSectionsDuration } from "../../../../../helpers/eventdisplay/renderSectionsDuration";
import OpenRequestIndicator from "../../../../../components/OpenRequestIndicator";
import { cn } from "../../../../../../../../lib/utils";

function Shift({ event }: any) {
    const { t } = useTranslation();
    const { openMenu } = useMenuContext();
    const { selectedEvents, selectedUnassignedEvents, ctrlShiftS, dispatch } = useScheduleContext();
    const preferenceStyle = useShiftPreferenceStyle(event);

    const onContextMenu = useCallback((e: any) => {
        e.preventDefault();
        e.stopPropagation();

        openMenu({
            id: event?.type === "unassigned"
                ? "unassigned-menu"
                : "event-menu",
            x: e.clientX,
            y: e.clientY + 10,
            selected: { ...event, isUnassignedShift: event?.type === "unassigned" },
            resource: event?.user
        });
    }, [openMenu, event]);

    const selectedElement = useMemo(() => {
        return [
            ...selectedEvents,
            ...selectedUnassignedEvents
        ]?.find((item: any) => item?.id === event?.id);
    }, [event?.id, selectedEvents, selectedUnassignedEvents]);

    const onEventChange = useCallback(() => {
        const type = event?.type === "unassigned"
            ? "select-unassign-event"
            : "select-event";
        dispatch({ type, payload: { event } });
    }, [dispatch, event]);

    return (
        <ShiftTooltip data={{ ...event, resource: event?.user }} side="right">
            <div
                className={cn(
                    "tw-border-l-2 tw-rounded-md tw-px-3 tw-py-1 tw-mb-1 tw-flex tw-truncate tw-gap-2 tw-items-center tw-cursor-pointer",
                    event.type === "unassigned" && "tw-bg-white tw-border tw-border-l-[3px] tw-border-dashed tw-border-rose-500"
                )}
                style={preferenceStyle}
                onContextMenu={onContextMenu}
            >
                <span className="tw-text-sm tw-font-medium tw-text-neutral-900 tw-flex tw-items-center">
                    {ctrlShiftS && (
                        <span
                            className="tw-flex tw-items-center tw-mr-1"
                            onClick={(e) => e.stopPropagation()}
                            onDoubleClick={(e) => e.stopPropagation()}
                        >
                            <Checkbox
                                id={event?.id}
                                className="tw-bg-white tw-p-0 tw-m-0"
                                checked={!!selectedElement}
                                onCheckedChange={onEventChange}
                                disabled={
                                    (event?.type === "unassigned" && selectedEvents?.length > 0) ||
                                    (selectedUnassignedEvents?.length > 0 && (!event?.type || event?.type !== "unassigned"))
                                }
                            />
                        </span>
                    )}
                    <OpenRequestIndicator event={event} className="tw-mr-1" />
                    {renderSectionsDuration(
                        moment(event.endDate).diff(moment(event.startDate), "seconds"),
                        event.sections
                    )}
                </span>
                <span className="tw-text-neutral-900 tw-truncate tw-text-sm">
                    {event?.type === "unassigned"
                        ? t("an-unassigned-event")
                        : event?.user?.lastName + ", " + event?.user?.firstName}
                </span>
            </div>
        </ShiftTooltip>
    );
}

export default Shift;
